import React, { useState, useEffect } from "react";

// Calculate the current month and year
const today = new Date();
const currentYear = today.getFullYear();
const getMonth = today.getMonth() + 1; // getMonth is zero-based
const currentMonth = getMonth < 10 ? "0" + getMonth : getMonth; // Pad single-digit months
const currentMonthYear = `${currentYear}-${currentMonth}`;

const MonthPicker = ({ onChange }) => {
  const [selectedMonth, setSelectedMonth] = useState(currentMonthYear);

  useEffect(() => {
    // Debugging: Log currentMonthYear and selectedMonth
    console.log("currentMonthYear:", currentMonthYear);
    console.log("selectedMonth:", selectedMonth);
  }, [selectedMonth]);

  const handleMonthChange = (event) => {
    const monthD = event.target.value;
    setSelectedMonth(monthD);
    onChange(monthD || currentMonthYear); // Ensure to call onChange with a valid value
  };

  return (
    <div>
      <input
        type="month"
        id="monthPicker"
        value={selectedMonth}
        onChange={handleMonthChange}
        style={{
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          color: "white",
          colorScheme: "dark",
          textAlign: "center",
        }}
      />
    </div>
  );
};

export default MonthPicker;
